import {toString, toList} from "../helpers/helpers";

const DEFAULT_MESSAGE = "";

export interface ValidationErrorRow {
  error: string;
  field: string;
  i18nFieldName: string;
  extraParam: any;
  processed: string;
}

export function validationErrorRowFactory(json: any): ValidationErrorRow {
  return {
    error: toString(json.error),
    field: toString(json.field),
    i18nFieldName: toString(json.i18nFieldName),
    extraParam: json.extraParam,
    processed: toString(json.processed),
  } as ValidationErrorRow;
}

export class ValidationError extends Error {
  validationErrors: ValidationErrorRow[];
  message: string;
  name: string = "ValidationError";

  static check(obj: any): boolean {
    if (!obj) return false;

    return Object.prototype.hasOwnProperty.call(obj, "validationErrors") &&
      obj["validationErrors"] !== null &&
      obj["validationErrors"] !== undefined &&
      obj["validationErrors"] instanceof Array;
  }

  constructor(json: any) {
    super("");
    Object.setPrototypeOf(this, ValidationError.prototype);

    if (!ValidationError.check(json)) throw new Error("Not a ValidationError");

    this.message = json["message"] || DEFAULT_MESSAGE;

    this.validationErrors = toList(validationErrorRowFactory, json["validationErrors"]);
  }

  get stack(): any {
    return this.validationErrors.map(error => error.processed).join("\n");
  }
}
